import { combineReducers, configureStore, PreloadedState } from "@reduxjs/toolkit"
import { configSlice } from "../common/utils/config-slice"
import { jobInfoSlice } from "../common/utils/job-info"
import { feedbackFormReducer } from "../features/feedback-form"
import { chromaticUrlSlice, infoDecryptionSlice, infoEncryptionSlice } from "../features/internal/test-hub-page/test-hub-slices"
import { pauseSlice } from "../features/pause-page/pause-slice"

const rootReducer = combineReducers({
    feedbackForm: feedbackFormReducer,
    config: configSlice.reducer,
    jobInfo: jobInfoSlice.reducer,
    pause: pauseSlice.reducer,
    debugDecryption: infoDecryptionSlice.reducer,
    debugEncryption: infoEncryptionSlice.reducer,
    chromaticUrl: chromaticUrlSlice.reducer,
})

export function setupStore(preloadedState?: PreloadedState<RootState>) {
    return configureStore({
        reducer: rootReducer,
        middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
        preloadedState,
    })
}

export type RootState = ReturnType<typeof rootReducer>
export type AppStore = ReturnType<typeof setupStore>
export type AppDispatch = AppStore["dispatch"]
